/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

/**
 * This module contains configuration information for relationship diagram
 *
 */
export default {
	themes: {
		default: {
			palette: {
				colors: '#1D3458;#B07CE8;#003569;#FFEEFF;#000033'/*Nodes Colors*/
			}
		}
	},
	default_show_concepts: false,
	legend_display: false,/**Show or Hide Legend*/
	links_color: 'rgb(176,124,232,0.7)',/**links color with opacity*/
	border_color: '#FFFFFF'/**border color*/,
	max_request_waiting_time: 2 * 60 * 1000,/**We abort the request after two mins*/
	request_progressive_status_timer_interval: 15 * 1000, /** We show progressive message after 15 seconds*/
	enable_cancel: false, /**Show Cancel link*/
	use_cached_data: true, /**When true, the relationship request's response is cached*/
	max_cached_data_pool_length: 20, /**By default, the max length of the cached data array is 20*/
	max_nodes_to_fetch: 100, /** default number of nodes asked in relationship strength request to Smarts/Predict */
	max_nodes_to_display: 100, /** max nodes we ever display in the relationship diagram */
	max_nodes_to_firstTime_display: 10, /** max nodes we want to display for the first time user selects an interesting field or change scope, data filter*/
	node_Link_ratio: 1.8, /** ratio of number of nodes and links displayed in the diagram **/
	default_show_primary_relationship_view: true,
	default_min_strength: 10, /** minimum relationship strength range by default */
	default_max_strength: 100, /** maximum relationship strength range by default */
	domain_setting_dataItem: 'Strengthsum', /**Data item that is used to set the domain values of link line thickness*/
	network_nodes_size_min: 350, /**default node size*/
	network_links_thickness_min: '3px', /**the minimum line thickness*/
	network_links_thickness_max: '12px', /**the maximum line thickness */
	max_scoped_columns: 100 /* maximum number of fields a user can select when edit scope */,
	diagram_status_bar_toast_time_duration: 10 * 1000 /*milliseconds*/,
	diagram_request_completed_toast_time_duration: 5 * 1000 /*milliseconds*/,
	request_execution_time_elapse_to_show_fulfilled_toast: 10 * 1000,//ms request execution elapse time
	max_number_override_badge_shown: 10,
	max_number_of_concurrent_requests: 3 /**Max number of concurrent relationship diagram requests */
};



// WEBPACK FOOTER //
// ./src/js/components/startingPoints/relationshipGraph/Config.js